export class ExecutionCache {
  private cache: Map<string, Map<string, any>> = new Map();

  cachedExecution<T>(key: string, fn: () => T, ...args: any[]): T {
    const argsKey = args.map(String).join('|');
    let cachedKey = this.cache.get(key);
    if (cachedKey !== undefined) {
      const cachedValue = cachedKey.get(argsKey);
      if (cachedValue !== undefined) {
        return cachedValue;
      }
    } else {
      cachedKey = new Map<string, any>();
      this.cache.set(key, cachedKey);
    }
    const result = fn();
    cachedKey.set(argsKey, result);
    return result;
  }
}
